'use client'

import { useTranslation } from 'next-i18next'

import { TEST_LOCATORS } from '@src/constants/test-locators'
import type { SizeChartButtonProps } from '@src/quince-components/src/atoms/productForm/SizeChartButton-legacy'

import { sizeChartButtonDsClass, sizeChartButtonStandaloneDsClass } from './size-chart-button-ds.styles'

// Native <button>, not the legacy Button atom: its unlayered rem SCSS balloons under panda and beats the layered Panda classes.
const SizeChartButtonDS = ({ onClick, isStandalone }: SizeChartButtonProps) => {
  const { t } = useTranslation('common')
  return (
    <button
      type="button"
      onClick={onClick}
      className={isStandalone ? sizeChartButtonStandaloneDsClass : sizeChartButtonDsClass}
      id={TEST_LOCATORS.SIZE_CHART_BUTTON}
      data-dd-action-name="size chart"
    >
      {t('size_chart')}
    </button>
  )
}

export default SizeChartButtonDS
